import Vue from 'vue'

const state = {
    mobileDevice: false,
    smDevice: false,
    lgDevice: true,
    size: null,
    isApple: false,
}

const mutations = {
    SET_DEVICE(state, data) {
        state.mobileDevice = data
    },
    SET_SIZE(state, data) {
        state.size = data
        state.smDevice = Vue.prototype.smallDeviceSize.includes(data)
        state.lgDevice = !state.smDevice
    },
    IS_APPLE(state, data) {
        state.isApple = data
    },
}

const actions = {
    setMobileDevice({ commit }, data) {
        commit('SET_DEVICE', data)
    },
    setSize({ commit }, data) {
        commit('SET_SIZE', data)
    },
    isApple({ commit }, data) {
        commit('IS_APPLE', data)
    },
}

const getters = {
    mobileDevice: (state) => state.mobileDevice,
    smDevice: (state) => state.smDevice,
    lgDevice: (state) => state.lgDevice,
    size: (state) => state.size,
    isApple: (state) => state.isApple,
    xxlUp: (state, getters) => ['xxl', 'xxxl'].includes(getters.size),
    isXs: (state, getters) => ['xs'].includes(getters.size),
}

export default {
    state,
    mutations,
    actions,
    getters,
}
